import { Anchor, Breadcrumbs, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import { getMenuUrl, useRestaurantId } from "../utils/restaurant";

export default function BreadcrumbsBar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const params = useParams();

  // Get restaurant ID from URL params or menu items
  const restaurantId = params.restaurantId || useRestaurantId();
  const homeLabel = i18n.language === "da" ? "Forside" : "Home";

  // Only show breadcrumbs on known routes; hide entirely on home
  const tailLabel = (() => {
    if (location.pathname.startsWith("/menu")) return t("nav.menu");
    if (location.pathname.startsWith("/cart")) return t("nav.cart");
    if (location.pathname.startsWith("/success"))
      return i18n.language === "da" ? "Ordre bekræftet" : "Order confirmed";
    return null;
  })();

  if (!tailLabel || location.pathname === "/") return null;

  const items: Array<{ label: string; to?: string }> = [
    { label: homeLabel, to: "/" },
    { label: t("home.restaurantName"), to: getMenuUrl(restaurantId) },
    { label: tailLabel },
  ];

  return (
    <div style={{ padding: "8px 12px" }}>
      <Breadcrumbs separator=">">
        {items.map((item, idx) =>
          item.to && idx < items.length - 1 ? (
            <Anchor
              key={idx}
              component={Link}
              to={item.to}
              underline="hover"
              c="dimmed"
              size="sm"
            >
              {item.label}
            </Anchor>
          ) : (
            <Text key={idx} size="sm">
              {item.label}
            </Text>
          )
        )}
      </Breadcrumbs>
    </div>
  );
}
